import React from 'react';

export function SecondNoteIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M16.2451 7.83001L15.5101 10.965C14.8801 13.6725 13.6351 14.7675 11.2951 14.5425C10.9201 14.5125 10.5151 14.445 10.0801 14.34L8.82014 14.04C5.69263 13.2975 4.72513 11.7525 5.46013 8.61751L6.19513 5.47501C6.34513 4.83751 6.52513 4.28251 6.75013 3.82501C7.62763 2.01001 9.12013 1.52251 11.6251 2.11501L12.8776 2.40751C16.0201 3.14251 16.9801 4.69501 16.2451 7.83001Z"
        fill="#12B76A"
      />
      <path
        d="M5.77441 4.72144C5.71626 4.92012 5.66119 5.12572 5.61133 5.33765V5.33862L4.87695 8.48022C4.49575 10.1062 4.51678 11.4707 5.18262 12.5427C5.84799 13.6139 7.06097 14.2389 8.68164 14.6238L9.3457 14.782H9.34668L9.3457 14.783L8.16406 15.1716C6.73112 15.6336 5.78519 15.6199 5.11133 15.2751C4.5216 14.9734 4.01532 14.3539 3.58594 13.2439L3.40625 12.7371L2.44629 9.77612H2.44727C1.98512 8.34276 1.99642 7.39444 2.33984 6.71948C2.6829 6.0455 3.44004 5.48005 4.87207 5.01831L4.87598 5.01733L5.77441 4.72144Z"
        fill="#12B76A"
        stroke="#12B76A"
        strokeWidth="1.2"
      />
      <path
        d="M13.118 7.88245C13.073 7.88245 13.028 7.87495 12.9755 7.86745L9.33802 6.94495C9.03802 6.86995 8.85802 6.56245 8.93302 6.26246C9.00802 5.96246 9.31552 5.78245 9.61552 5.85745L13.253 6.77995C13.553 6.85495 13.733 7.16245 13.658 7.46245C13.598 7.70995 13.3655 7.88245 13.118 7.88245Z"
        fill="white"
      />
      <path
        d="M10.9208 10.4175C10.8758 10.4175 10.8308 10.41 10.7783 10.4025L8.59583 9.84754C8.29583 9.77254 8.11583 9.46504 8.19083 9.16504C8.26583 8.86504 8.57333 8.68504 8.87333 8.76004L11.0558 9.31504C11.3558 9.39004 11.5358 9.69754 11.4608 9.99754C11.4008 10.2525 11.1758 10.4175 10.9208 10.4175Z"
        fill="white"
      />
    </svg>
  );
}
